import template from './rw-editor.html';

const mapStateToThis = ({ config }) => {
  const { ckeditor } = config;

  return {
    ckeditor,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class RwEditorController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class RwEditorComponent {
  constructor() {
    this.controller = RwEditorController;
    this.template = template;
    this.bindings = {
      content: '=',
      isRequired: '<',
      label: '@',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-editor/rw-editor-component.js